import { render, staticRenderFns } from "./contact_roles.vue?vue&type=template&id=4d3e014a&scoped=true&"
import script from "./contact_roles.vue?vue&type=script&lang=js&"
export * from "./contact_roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e014a",
  null
  
)

export default component.exports